export default __webpack_public_path__ + "static/media/persistent-drawer-pitfall.653c2105.gif";